import './tik_tok_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TikTokAdContent extends Monitoring.Models.SocialContents.TikTokContent

  userId: ->
    return @username()

  username: ->
    return @data().author_name

  getRootParentId: ->
    return @get('id')

  rootPostId: ->
    return @data().parent_post_id

  rootAdExternalId: ->
    return @externalId()

  rootPostExternalId: ->
    return @externalId()

  isPost: ->
    return true

  defaultAvatar: ->
    return window.image_path('default_avatars/tiktok/tiktok_ad.png')

  isVideo: ->
    return @data().ad_details && @data().ad_details.preview_url

  videoUrl: ->
    return @data().ad_details.preview_url

  videoThumbnailUrl: ->
    return @data().ad_details.cover_url
